import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import Slide from '../../../components/slide/slide.jsx'
import Button from '../../../components/button/button.jsx'
import CursorIcon from '../../../components/cursor-icon/cursor-icon.jsx'
import Heading from '../../../components/heading/heading.jsx'
import ColumnsLayout from '../../../components/columns-layout/columns-layout.jsx'
import SlideText from '../../../components/slide-text/slide-text.jsx'
import { withPresentation } from '../../../presentation-connectors'
import classNames from 'classnames'

const styles = ({ COLORS }) => ({
  title: ({ size }) => ({
    margin: `0 0 ${size(3.2, { scaleFactor: 'sm' })}`
  }),
  button: ({ size }) => ({
    fontSize: size(1.4, { scaleFactor: 'sm' })
  }),
  description: ({ size }) => ({
    margin: `0 0 ${size(3.2)}`,
    color: COLORS.TEXT.MID_GREY.NORMAL
  }),
  columns: {},
  printMode: {
    '& $columns': {
      '& > *': {
        width: '100%',
        '&:first-child': {
          display: 'none'
        }
      }
    }
  }
})

const ExemplarSlide = ({ classes, slides, id, printMode }) => {
  const data = slides[id]

  const slideData = useMemo(
    () => ({
      link: `/works/${data.work.id}`,
      title: data.title,
      description: data.description,
      descriptionHTML: data.html_description,
      image: !data.work.media ? null : data.work.media[0].image_url,
      notAvailable: !data.work.media
    }),
    [data]
  )

  return (
    <Slide className={classNames({ [classes.printMode]: printMode })}>
      <ColumnsLayout
        className={classes.columns}
        image={slideData.image}
        alt={slideData.description}>
        <Heading className={classes.title}>
          {slideData.notAvailable ? 'Sorry...' : slideData.title}
        </Heading>
        <SlideText
          className={classes.description}
          html={
            slideData.notAvailable
              ? 'This exemplar is not available anymore, it may have been deleted or flagged by his owner or another user.'
              : slideData.descriptionHTML
          }
        />
        {!slideData.notAvailable && (
          <Button
            icon={<CursorIcon />}
            target="_blank"
            href={slideData.link}
            className={classes.button}>
            View on Pobble
          </Button>
        )}
      </ColumnsLayout>
    </Slide>
  )
}

export default withPresentation(injectSheet(styles)(ExemplarSlide))
